// extracted by mini-css-extract-plugin
export default {"tableHeader":"dataTable_tableHeader__lkaV+","noBg":"dataTable_noBg__3fZyU"};